import { render, staticRenderFns } from "./vip-tab-zgz.vue?vue&type=template&id=4144492a&scoped=true&"
import script from "./vip-tab-zgz.vue?vue&type=script&lang=js&"
export * from "./vip-tab-zgz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4144492a",
  null
  
)

export default component.exports